import { createSelector } from 'reselect'

import { userCredentialsSelector } from 'redux/selectors/user'

const interactiveVideoCreationSelector = state => state.interactiveVideoCreation
const oeqActivitySelector = state => state.creationTool.oeq

const oeqContainerSelector = createSelector(
	[
		interactiveVideoCreationSelector,
		oeqActivitySelector,
		userCredentialsSelector,
	],
	(
		interactiveVideoCreationData,
		oeqData,
		userCredentials,
	) => {

		const question = oeqData.question
		const formattedQuestion = {
			...question,
			id: oeqData.activityUid, // To mantain compatibility with the old view
			hasErrors:
				(
					!question.text
					|| question.text.trim() === ''
				)
				&& !question.textTouched,
		}

		return {
			jwt: userCredentials.interactiveVideo,
			question: formattedQuestion,
			isModified: oeqData.isModified,
			isEdition: interactiveVideoCreationData.currentActivity.isEdition,
		}
	}
)

export default oeqContainerSelector
